import React, { useState, useContext, useEffect } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";
import { useNavigate } from "react-router-dom"; // Usamos useNavigate

// @material-ui/core components
import { LogoutOutlined } from "@mui/icons-material";
// core components
import { Stack, Avatar, Grid, Button, Box } from "@mui/material";

import PopupLogout from "views/Dialog/PopupLogout";

import avatar from "assets/img/undraw_hombre.png";

import { blackColor, TitleTextPage } from "components/cardBodyStyle";

export default function AdminNavbarLinks(props) {
  const navigate = useNavigate(); // Usamos useNavigate para redirigir

  const [popupLogout, setpopupLogout] = React.useState(false);
  const [error, setError] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mensageSystem, setMensageSystem] = useState("");
  const [rows, setRows] = useState([]);
  const [isAnimating, setIsAnimating] = useState(false);

  const open = Boolean(anchorEl);

  const { UserAuth } = useContext(UrlServicesContext);

  const handleOpenpopupLogout = () => {
    setpopupLogout(true);
  };

  const handleClosepopupLogout = () => {
    setpopupLogout(false);
  };

  return (
    <div>
      <Grid container>
        <Grid xs={12} md={12} sx={{ display: { xs: "block", sm: "none" } }}>
          <center>
            <Box
              component="b"
              sx={{
                fontSize: 10,
                color: { xs: "#000", sm: "#ffffff" },
              }}
            >
              {UserAuth?.clientsName || UserAuth?.allname}
            </Box>
            <Button
              aria-haspopup="true"
              onClick={handleOpenpopupLogout}
              endIcon={
                <LogoutOutlined
                  sx={{
                    fontSize: 24,
                    color: { xs: "#000", sm: "#ffffff" },
                  }}
                />
              }
            ></Button>
          </center>
        </Grid>
        <Grid xs={12} md={12} sx={{ display: { xs: "none", sm: "block" } }}>
          <Stack
            direction="row"
            spacing={2}
            sx={{
              position: { xs: "absolute", sm: "static" },
              bottom: "5%",
              mb: { xs: 5, sm: 0 },
              float: "right",
            }}
          >
            <Box sx={{ display: { xs: "none", sm: "block" } }}>
              <Avatar
                src={UserAuth.avatar ? UserAuth.avatar : avatar}
                style={{ width: 30, height: 30 }}
              />
            </Box>
            <Box
              component="b"
              sx={{
                pt: "10px",
                fontSize: 10,
                color: blackColor,
              }}
            >
              {UserAuth.name || UserAuth.clientsName}
              {/*<div style={{ marginTop: "-8px", color: "gray" }}>
                  {UserAuth.profile_name}
                </div>*/}
            </Box>
            <Button
              aria-haspopup="true"
              onClick={handleOpenpopupLogout}
              endIcon={
                <LogoutOutlined
                  sx={{
                    fontSize: 24,
                    color: blackColor,
                    marginLeft: "-30px",
                  }}
                />
              }
            ></Button>
          </Stack>
        </Grid>
      </Grid>
      {popupLogout && (
        <PopupLogout open={popupLogout} exit={handleClosepopupLogout} />
      )}
    </div>
  );
}
